export function TeamliveSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/teamlive.svg'"></ng-include>`
    }
}